<template>
  <div class="navbar">
    <!-- 公司logo -->
    <div class="logo-container">
      <div :style="{ backgroundImage: `url(${require('../assets/logo.png')})` }" class="logo">
      </div>
    </div>
    
    <!-- 导航菜单 -->
    <el-menu :default-active="route.fullPath" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="/">首页</el-menu-item>
      <el-menu-item index="/about">关于我们</el-menu-item>
      <el-menu-item index="/honors">荣誉资质</el-menu-item>
      <el-menu-item index="/cooperative">主营业务</el-menu-item>
      <el-menu-item index="/product">工程案例</el-menu-item>
      <el-menu-item index="/news">新闻资讯</el-menu-item>
      <el-menu-item index="/contact">联系我们</el-menu-item>
    </el-menu>
    
    <!-- 联系电话 -->
    <div class="phone-container">
      <h4 style="color: #4768F0;"><el-icon :size="35"><PhoneFilled /></el-icon> 0731-56780003</h4>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { PhoneFilled } from '@element-plus/icons-vue'
const route = useRoute()
</script>

<style lang="scss">
.navbar {
  position: sticky;
  top: 0px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 80px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.logo-container {
  display: flex;
  align-items: center;
  width: 200px;
  height: 100px;
}

.logo {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.el-menu-demo {
  flex: 1;
  justify-content: center;
  background-color: transparent;
  border-bottom: none !important; /* 确保移除底部边框 */
  box-shadow: none !important; /* 移除可能存在的阴影效果 */
  --el-menu-active-color: #3f5ff0;
  --el-menu-hover-bg-color: transparent;
  --el-menu-hover-text-color: #3f5ff0;
}

/* 移除Element UI默认的底部边框样式 */
.el-menu-demo::after {
  display: none;
}

.el-menu-demo .el-menu-item {
  color: #606266;
}

.el-menu-demo .el-menu-item.is-active {
  color: #3f5ff0;
}

.el-menu-demo .el-menu-item {
  font-size: 16px;
  color: #333;
}

.el-menu-demo .el-menu-item:hover,
.el-menu-demo .el-menu-item.is-active {
  color: #4768F0;
  border-bottom: 2px solid #4768F0;
}

.phone-container {
    display: flex;
    align-items: center;
    width: 200px;
    height: 100px;
    padding: 8px 16px;
    justify-content: flex-end;
  }

.phone-container h4 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 20px;
  font-weight: 500;
}

.phone-icon {
  font-size: 24px;
  color: #4768F0;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }
  
  .logo-container {
    margin-bottom: 10px;
    width: 100px;
    height: 50px;
  }
  
  .el-menu-demo {
    flex: 1;
    border-bottom: none !important;
    box-shadow: none !important;
    width: 100%;
    overflow-x: auto;
  }

  .el-menu-demo::after {
    display: none;
  }
  
  .phone-container {
    margin-top: 10px;
    min-width: auto;
  }
  
  .phone-container h4 {
    font-size: 14px;
  }
}
</style>